import { render, staticRenderFns } from "./CustomTable.vue?vue&type=template&id=1be94d5e&scoped=true&"
import script from "./CustomTable.vue?vue&type=script&lang=ts&"
export * from "./CustomTable.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1be94d5e",
  null
  
)

export default component.exports